export const API_URL = "https://apidev.amolebet.com/";
// export const API_URL = "http://localhost:8000/";
export const secret = "2)Td6,)kd1^027D8q]_t";
export const CURRENCY = "ETB";
export const PROVIDERS_WITHOUT_DEMO = ["aviator", "pragmaticlive"];
